// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    COMPANY_INDEX_SECTION_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_INDEX_SECTION_LOADED() {
      return {
        isLoading: false,
        data: action.companyIndexSection
      };
    },
    COMPANY_INDEX_SECTION_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexSection.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
